/* eslint no-console: 0 */
let isDebugging = JSON.parse(window.sessionStorage.getItem('hjDebug') || 'null');

export function getDebugParamFromURL(): string | null {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get('hjDebug');
  } catch {
    return null;
  }
}

const debugParamFromURL = getDebugParamFromURL();

function on(): void {
  isDebugging = true;
  window.sessionStorage.setItem('hjDebug', JSON.stringify(true));
  console.log('Debugging mode is now on.');
}

function off(): void {
  isDebugging = false;
  window.sessionStorage.setItem('hjDebug', JSON.stringify(false));
  console.log('Debugging mode is now off.');
}

if (debugParamFromURL === 'true') {
  on();
} else if (debugParamFromURL === 'false') {
  off();
}

if (isDebugging) {
  console.log('Debugging mode is on.');
}

function debug(message: string): void {
  if (isDebugging) {
    console.log(`DEBUG: ${message}`);
  }
}

function warn(message: string): void {
  console.log(`WARN: ${message}`);
}

export const log = { on, off, debug, warn };
